export const POST = "POST";
export const GET = "GET";
export const PUT = "PUT";
export const DELETE = "DELETE";

const basicAuth = "Basic " + btoa("admin:Telwin2023!"); //.toString("base64");

export const ZDMFetch = (
  method: string,
  url: string,
  param?: string,
  auth?: string
): Promise<any> => {
  return fetch(url, {
    method: method,
    credentials: "include",
    body: param,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: auth ? auth : basicAuth,
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.log(error);
    });
};
